export enum ContainerSelectionMethod {
  ALREADY_AVAILABLE = 'ALREADY_AVAILABLE',
  DRIVER = 'DRIVER',
  YARD = 'YARD',
  PROVIDE_LATER = 'PROVIDE_LATER'
}
